export function measureTime<T>(action: () => T) {
  const timeBeforeExecution = Date.now(); // performance.now is not available on Mobile
  const result = action();
  const timeAfterExecution = Date.now();
  const executionTimeInMs = timeAfterExecution - timeBeforeExecution;
  return {
    result,
    executionTimeInMs,
  };
}
